import { IFriendsState, IRelationUsersResponse } from "./types";

import { fetchRelationUsers } from "./services";

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IFriendsState = {
    friends: [],
    loading: false,
    error: null,
};

const relationUsersSlice = createSlice({
    name: 'relationUsers',
    initialState,
    reducers: {
        resetRelationUsersState: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchRelationUsers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchRelationUsers.fulfilled, (state, action: PayloadAction<IRelationUsersResponse>) => {
                state.loading = false;
                state.friends = action.payload.response.collection;
            })
            .addCase(fetchRelationUsers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string || 'Failed to fetch friends';
            });
    },
});

export const relationUsersReducer = relationUsersSlice.reducer;
export const { resetRelationUsersState } = relationUsersSlice.actions;
